export default __webpack_public_path__ + "static/media/logo.b5614760.svg";